export const numberTransform = (price) => price ? (Math.round(price * 100) / 100).toFixed(2) : '0.00';
